import React from "react";
import "./index.css"; // Estilos
import "./App.css"; // Estilos
import Email from "./components/Email";

const App = () => {
    return (
        <div style={{ marginTop: "1em", textAlign: "center" }}>
            <Email/>
        </div>
    );
};

export default App;
